import apiClient from "../apiClient";
import { ENDPOINTS } from "../endpoints";

export const planService = {
  list: async (params = {}) => (await apiClient.get(ENDPOINTS.plans, { params })).data,
  get: async (id) => (await apiClient.get(ENDPOINTS.plan(id))).data,
  create: async (payload) => (await apiClient.post(ENDPOINTS.plans, payload)).data,
  update: async (id, payload) => (await apiClient.patch(ENDPOINTS.plan(id), payload)).data,
  start: async (id) => (await apiClient.post(ENDPOINTS.planStart(id))).data,
  complete: async (id) => (await apiClient.post(ENDPOINTS.planComplete(id))).data,
  delete: async (id) => (await apiClient.delete(ENDPOINTS.plan(id))).data,
  addTickets: async (id, ticketIds) =>
    (await apiClient.post(ENDPOINTS.planTickets(id), { ticket_ids: ticketIds })).data,
  removeToBacklog: async (ticketIds) =>
    (await apiClient.post(ENDPOINTS.planBacklogTickets, { ticket_ids: ticketIds })).data,
};
